/* SW custom — comprar agora, guia de medidas, contador, atalho da sacola */
(function () {
  function qs(s, r) { return (r || document).querySelector(s); }

  document.addEventListener('click', async function (e) {
    var buy = e.target.closest('[data-sw-buy-now]');
    if (buy) {
      e.preventDefault();
      var scope = buy.closest('.shopify-section') || document;
      var idInput = scope.querySelector('form[action*="/cart/add"] [name="id"]') || scope.querySelector('[name="id"]');
      var qtyInput = scope.querySelector('input[name="quantity"]');
      var id = idInput && idInput.value ? idInput.value : buy.dataset.fallbackVariant;
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      buy.classList.add('is-loading'); buy.disabled = true;
      try {
        var r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
        });
        if (!r.ok) { var j = await r.json().catch(function () { return {}; }); throw new Error(j.description || 'Não foi possível adicionar.'); }
        window.location.href = (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url) || '/cart';
      } catch (err) {
        alert(err.message || 'Selecione um tamanho disponível.');
        buy.classList.remove('is-loading'); buy.disabled = false;
      }
      return;
    }
    var opener = e.target.closest('[data-sw-open]');
    if (opener) {
      var d = document.getElementById(opener.getAttribute('data-sw-open'));
      if (d && d.showModal) { d.showModal(); document.documentElement.classList.add('sw-lock'); }
      return;
    }
    var closer = e.target.closest('[data-sw-close]');
    if (closer) { var dl = closer.closest('dialog'); if (dl) dl.close(); return; }
    if (e.target.matches && e.target.matches('dialog.sw-dialog')) { e.target.close(); return; }
    var cartLink = e.target.closest('[data-sw-open-cart]');
    if (cartLink) {
      var drawer = qs('#cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        e.preventDefault();
        drawer.open();
      }
    }
  });
  document.addEventListener('close', function (e) { if (e.target.classList && e.target.classList.contains('sw-dialog')) document.documentElement.classList.remove('sw-lock'); }, true);

  function tick() {
    document.querySelectorAll('[data-sw-countdown]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-sw-countdown')).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      var diff = Math.max(0, end - Date.now());
      var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
      var p = function (n) { return String(n).padStart(2, '0'); };
      el.querySelector('[data-d]').textContent = p(d); el.querySelector('[data-h]').textContent = p(h);
      el.querySelector('[data-m]').textContent = p(m); el.querySelector('[data-s]').textContent = p(s);
    });
  }
  tick(); setInterval(tick, 1000);
})();


/* Se Vira — WhatsApp de contato: protege os botoes de compra no celular. */
(function () {
  function init() {
    var cta = document.querySelector('#MainContent .product-details [data-sw-buy-now]');
    if (!cta || !('IntersectionObserver' in window)) return;
    var mobile = window.matchMedia('(max-width: 749px)');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        document.body.classList.toggle('sv-wa-buy-visible', mobile.matches && entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px 35px 0px', threshold: 0.01 });
    observer.observe(cta);
    if (mobile.addEventListener) {
      mobile.addEventListener('change', function () {
        if (!mobile.matches) document.body.classList.remove('sv-wa-buy-visible');
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
